import SharedAgoraVideoCallSurface from './SharedAgoraVideoCallSurface'

export default function ChamberScreenAgoraVideoSurface({
  rtcProps,
  rtmProps,
  callbacks,
  styleProps = {},
  fallback = null,
  shell = null,
  handleLeaveRoom,
  layoutId = null,
  onLayoutChange = null,
  railStateId = null,
  onRailStateChange = null,
  showLayoutSelector = null,
  showRailSelector = null,
}) {
  return (
    <SharedAgoraVideoCallSurface
      shell={shell}
      fallback={fallback}
      rtcProps={rtcProps}
      rtmProps={rtmProps}
      callbacks={callbacks}
      styleProps={styleProps}
      handleLeaveRoom={handleLeaveRoom}
      layoutId={layoutId}
      onLayoutChange={onLayoutChange}
      railStateId={railStateId}
      onRailStateChange={onRailStateChange}
      showLayoutSelector={showLayoutSelector}
      showRailSelector={showRailSelector}
    />
  )
}

ChamberScreenAgoraVideoSurface.displayName = 'ChamberScreenAgoraVideoSurface'
